import React from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineLockClosed } from "react-icons/hi";
import FeatureCtaCard from "../../common/FeatureCtaCard";

const AiUpgradeCta: React.FC<{ onUpgrade: () => void }> = ({ onUpgrade }) => {
  const { t } = useTranslation();

  return (
    <FeatureCtaCard
      icon={<HiOutlineLockClosed size={22} />}
      title={t("dashboard.aiConfig.cta.title")}
      body={t("dashboard.aiConfig.cta.body") as string}
      ctaLabel={t("dashboard.aiConfig.upsell.ctaLabel") as string}
      onCta={onUpgrade}
    />
  );
};

export default AiUpgradeCta;
